import React from "react";
import AllAdmin from "../../components/AllAdmin";

function Admins() {
  return (
    <div>
      <AllAdmin />
    </div>
  );
}

export default Admins;
